<template>
    <div>
        <ReoEditDescription
            :title="$t('dashboard.device_detail.cloud_video_history')"
            :subDevice="subDevice"
            :subscription="subscription"
            :planInfo="planInfo"
            @refresh="getDeviceInfos"
        />
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapGetters } from 'vuex';
import {
    IGetPlanByIdRes,
    IPlan,
    IReolinkDevice,
    ISubDevice, ISubscription
} from '@reolink-cloud/interface';
import { getDeviceList } from '@/api/cloud';
import { unfoldError } from '@/common/js/notice';
import { getSubDeviceList, getSubscriptionById } from '@/api/subscriptions';
import { Async } from '@reolink-web/utils';
import { getPlanById } from '@/api/cart';
import store from '@/store';
import ReoEditDescription from 'VIEW/user/MySim/components/components/ReoEditDescription.vue';

export default Vue.extend({
    components: { ReoEditDescription },
    name: 'ReoEdit',
    props: {
        uid: String,
    },
    data() {

        return {
            deviceInfo: {} as IReolinkDevice,
            subDevice: undefined as ISubDevice | undefined,
            subscription: undefined as ISubscription | undefined,
            planInfo: undefined as IPlan | undefined,
            init: false,
        };

    },
    computed: {
        ...mapGetters( ['lang', 'country'] as const ),
    },
    async created() {

        try {

            await Promise.all( [
                this.getDeviceInfos(),
                await store.dispatch( 'initGetCMKS' )
            ] );

        } catch ( e ) {

            console.error( e );
            unfoldError( 'errors.server_error' );

        }

    },
    methods:{
        async getDeviceInfos() {

            const [deviceList, subDeviceList] = await Promise.all( [
                getDeviceList(),
                getSubDeviceList(),
            ] );
            const device = deviceList.find( item => item.uid === this.uid );
            const subDevice = subDeviceList.find( item => item.uid === this.uid );
            if ( !device ) {

                unfoldError( 'errors.server_error' );
                setTimeout(() => {

                    Async.invokeAsync( async () => {

                        await this.$router.push({ path: '/user/my-devices' });

                    });

                }, 1000 );
                return;

            }
            this.deviceInfo = device;
            this.subDevice = subDevice;
            if ( subDevice && subDevice.status === 'associated' ) {

                let planAndSeries: IGetPlanByIdRes;
                [this.subscription, planAndSeries] = await Promise.all( [
                    getSubscriptionById( subDevice.subscription ),
                    getPlanById( subDevice.plan, this.lang )
                ] );
                if ( this.subscription.status === 'inactive' ) {

                    this.subscription = undefined;

                }
                planAndSeries.plan.title = planAndSeries.series.i18n.name;
                this.planInfo = planAndSeries.plan;

            }

            this.init = true;

        },
    }
});
</script>
